import { jsx as g, Fragment as v } from "react/jsx-runtime";
import k, { useMemo as E, createContext as S, useContext as T, useCallback as m } from "react";
import { useQuery as y } from "@apollo/client";
const h = ({
  useContext: r
}) => ({
  componentMap: o,
  segmentMap: e,
  loading: i
}) => {
  const { user: a, result: d, supportedSegments: p } = r(), x = E(() => {
    var t;
    const u = ((t = d.data) == null ? void 0 : t.findSegmentationTargetedLeverExperiments.segmentDataPayload.segmentsApplied) || [], c = Object.entries(p).reduce((s, n) => (s[n[1]] = n[0], s), {});
    for (const s of u) {
      const n = e[c[s]];
      if (n && (!n.condition || n.condition(a)))
        return n.componentOrder;
    }
    return e.__default.componentOrder;
  }, [e, a, d, p]);
  return d.loading ? /* @__PURE__ */ g(v, { children: i }) : /* @__PURE__ */ g(v, { children: x.map((u) => {
    const { condition: c, render: t } = o[u];
    return /* @__PURE__ */ g(k.Fragment, { children: !c || c(a) ? t() : null }, String(u));
  }) });
}, A = () => S(
  void 0
), C = ({
  Context: r
}) => () => {
  const o = T(r);
  if (!o)
    throw new Error("useTargetedExperienceContext must be used within a TargetedExperienceProvider");
  const { result: e, supportedSegments: i, supportedOccupationGroups: a } = o, d = m(
    (t) => {
      var n;
      if (!e.data)
        return !1;
      const s = String(i[t]);
      return i[t] ? !!((n = e.data.findSegmentationTargetedLeverExperiments) != null && n.segmentDataPayload.segmentsApplied.includes(s)) : !1;
    },
    [e.data, i]
  ), p = m(
    (t) => {
      var n;
      if (!e.data)
        return !1;
      const s = (n = e.data.findSegmentationTargetedLeverExperiments) == null ? void 0 : n.segmentDataPayload.occupationIdsApplied;
      if (!s || s.length === 0 || !a[t])
        return !1;
      for (const f of s)
        if (Object.values(a[t]).includes(f))
          return !0;
      return !1;
    },
    [e.data, a]
  ), x = m((t) => {
    throw new Error("This method is planned, but not yet supported.");
  }, []), u = m((t) => {
    throw new Error("This method is planned, but not yet supported.");
  }, []), c = m((t) => {
    throw new Error("This method is planned, but not yet supported.");
  }, []);
  return {
    ...o,
    user: {
      isInSegment: d,
      hasTaxonomyConcept: x,
      hasBroaderTaxonomyConcept: u,
      hasNarrowerTaxonomyConcept: c,
      isInOccupationGroup: p
    }
  };
}, L = ({
  Context: r,
  supportedSegments: o,
  supportedTaxonomyConcepts: e,
  supportedOccupationGroups: i
}) => ({ children: a, queryResult: d }) => /* @__PURE__ */ g(
  r.Provider,
  {
    value: {
      result: d,
      supportedSegments: o,
      supportedTaxonomyConcepts: e,
      supportedOccupationGroups: i
    },
    children: a
  }
), l = { createComponent: h, createContext: A, createHook: C, createProvider: L }, I = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "FindTargetedLeverExperiments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "targetedLeverExperimentsInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "SegmentationTargetedLeverExperimentsInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findSegmentationTargetedLeverExperiments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "targetedLeverExperimentsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentDataPayload" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "occupationIdsApplied" } }, { kind: "Field", name: { kind: "Name", value: "proctorGroupsApplied" } }, { kind: "Field", name: { kind: "Name", value: "segmentsApplied" } }, { kind: "Field", name: { kind: "Name", value: "targetingApiSegmentsApplied" } }] } }] } }] } }] }, N = {
  "\n    query FindTargetedLeverExperiments($targetedLeverExperimentsInput: SegmentationTargetedLeverExperimentsInput!) {\n        findSegmentationTargetedLeverExperiments(input: $targetedLeverExperimentsInput) {\n            segmentDataPayload {\n                occupationIdsApplied\n                proctorGroupsApplied\n                segmentsApplied\n                targetingApiSegmentsApplied\n            }\n        }\n    }\n": I
};
function b(r) {
  return N[r] ?? {};
}
const F = b(`
    query FindTargetedLeverExperiments($targetedLeverExperimentsInput: SegmentationTargetedLeverExperimentsInput!) {
        findSegmentationTargetedLeverExperiments(input: $targetedLeverExperimentsInput) {
            segmentDataPayload {
                occupationIdsApplied
                proctorGroupsApplied
                segmentsApplied
                targetingApiSegmentsApplied
            }
        }
    }
`), O = (r) => y(F, {
  variables: {
    targetedLeverExperimentsInput: r
  }
}), G = ({
  supportedSegments: r,
  supportedTaxonomyConcepts: o,
  supportedOccupationGroups: e
}) => {
  const i = l.createContext(), a = l.createProvider({
    Context: i,
    supportedSegments: r,
    supportedTaxonomyConcepts: o,
    supportedOccupationGroups: e
  }), d = l.createHook({
    Context: i
  }), p = l.createComponent({
    useContext: d,
    supportedTaxonomyConcepts: o,
    supportedSegments: r
  });
  return { TargetedExperienceProvider: a, useTargetedExperienceContext: d, TargetedExperience: p, TargetedExperienceContext: i };
};
export {
  G as createTargetedExperience,
  O as useTargetedExperienceQuery
};
